interface PipelineStepProps {
  name: string;
  status: "pending" | "running" | "completed" | "failed";
  elapsed?: string | null;
  error?: string | null;
}

export default function PipelineStep({
  name,
  status,
  elapsed,
  error,
}: PipelineStepProps) {
  return (
    <div className="flex items-start gap-3 py-3">
      <div className="flex-shrink-0 mt-0.5">{statusIcon(status)}</div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span
            className={`text-sm sm:text-base font-medium ${
              status === "completed"
                ? "text-green-400"
                : status === "running"
                ? "text-blue-400"
                : status === "failed"
                ? "text-red-400"
                : "text-slate-500"
            }`}
          >
            {name}
          </span>
          {status === "completed" && elapsed && (
            <span className="text-xs text-slate-500">({elapsed})</span>
          )}
          {status === "running" && (
            <span className="text-xs text-slate-500">...</span>
          )}
        </div>
        {status === "failed" && error && (
          <p className="text-xs text-red-400/80 mt-1">{error}</p>
        )}
      </div>
    </div>
  );
}

function statusIcon(status: string) {
  switch (status) {
    case "completed":
      return (
        <svg className="w-5 h-5 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      );
    case "running":
      return (
        <svg className="w-5 h-5 text-blue-400 animate-spin" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
        </svg>
      );
    case "failed":
      return (
        <svg className="w-5 h-5 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      );
    default:
      return (
        <svg className="w-5 h-5 text-slate-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <circle cx="12" cy="12" r="10" />
        </svg>
      );
  }
}
